export default __webpack_public_path__ + "static/1_9-7461f296f9e83804fa61be673abb62e1.png";